import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    state => state.changeUserGroup
)

export const selectIsChangeUserGroupModalOpen = createSelector(
    baseSelector,
    (state) => state.isChangeUserGroupModalOpen
)

export const selectOnSuccess = createSelector(
    baseSelector,
    (state) => state.onSuccess
)

export const selectCurrentUser = createSelector(
    baseSelector,
    (state) => state.currentUser
)

